<template>
  <div
    class="defect-panel-header defect-panel-header--string d-flex align-center"
    :class="{ 'defect-panel-header--pinned': pinned }"
    :style="{ height: height + 'px' }"
    @click="$emit('click')"
  >
    <div class="solvit-de-string-indent" style="width: 16px; flex-shrink: 0" />
    <div
      class="d-flex align-center justify-center flex-shrink-0 solvit-de-icon-col"
      style="padding-left: 0 !important"
    >
      <v-icon small>
        {{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
      </v-icon>
    </div>
    <div
      class="text-overflow-ellipsis flex-grow-1 solvit-de-info-cell body-2 font-weight-medium"
      style="min-width: 0"
    >
      <RailListEllipsisTooltip
        :text="label"
        :item-key="rowKey"
        :epoch="tooltipEpoch"
        key-prefix="de-string"
        text-class="font-weight-medium"
        :text-style="{ color: stringColor }"
      />
    </div>
    <div class="solvit-de-trailing-col d-flex flex-shrink-0 pr-2" aria-hidden="true">
      <span class="solvit-de-trailing-defect-col" />
      <span class="solvit-de-trailing-edit-col" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DefectStringHeaderRow',
    components: {
      RailListEllipsisTooltip: () => import('@/components/common/RailListEllipsisTooltip.vue')
    },
    props: {
      row: { type: Object, required: true },
      label: { type: String, required: true },
      rowKey: { type: String, default: '' },
      tooltipEpoch: { type: Number, default: 0 },
      height: { type: Number, default: 52 },
      expanded: { type: Boolean, default: false },
      pinned: { type: Boolean, default: false }
    },
    computed: {
      stringColor() {
        return '#1E88E5';
      }
    }
  };
</script>
